import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-100", attrs: { "data-qa": "club_pending_payment" } },
    [
      _c(
        "h1",
        { staticClass: "text-h5 text--text text-center mb-4" },
        [
          _vm._v("\n    Оплатите\n    "),
          !_setup.cardDateEnd && _vm.cardPrice
            ? [_vm._v("\n      доступ к клубу и\n    ")]
            : _vm._e(),
          _vm._v("\n    опцион на скидку\n  "),
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column align-center gr-4" },
        [
          !_vm.hasEmail
            ? _c(_setup.EmailForm, {
                on: {
                  cancel: function ($event) {
                    _setup.isOpenedEmailForm = false
                  },
                  submit: _setup.createCouponRequest,
                },
                model: {
                  value: _setup.isOpenedEmailForm,
                  callback: function ($$v) {
                    _setup.isOpenedEmailForm = $$v
                  },
                  expression: "isOpenedEmailForm",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            VBtn,
            {
              class: { "w-100": _setup.isMobile },
              attrs: {
                "data-qa": "club__nodeButtonPayment",
                color: "primary",
                depressed: "",
              },
              on: { click: _setup.handlePayment },
            },
            [
              _vm._v(
                "\n      Оплатить " +
                  _vm._s(_setup.getFormattedPrice(_vm.totalPrice)) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(_setup.AgreementInfo),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "text-subtitle-1 text-center text-error--text mb-6" },
      [
        _vm._v("\n    Иначе запись отменится через\n    "),
        _c("time", {
          staticClass: "expire-time-box",
          attrs: { "data-qa": "club__nodeTimer" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }